module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"start":{"notifications":{"button":"Show all notifications","description":"Your newest notifications at a glance","title":"Notifications"}}}}}}')
  delete Component.options._Ctor
}
